<section class="users-page">
  <mat-card class="table-surface-card users-table-card">
    <mat-card-content>
      <app-table-surface
        tableId="user-list-v2"
        title="Usuarios"
        titleIcon="person"
        [columns]="columns"
        [fitContainer]="true"
        [activeFilters]="activeFilterChips"
        [enableFilter]="true"
        [data]="tableData"
        [isLoading]="isLoading"
        [errorMessage]="errorMessage"
        [paginationConfig]="paginationConfig"
        [showPageSizeSelector]="true"
        [pageSizeOptions]="[10, 25, 50, 100]"
        [enableSearch]="true"
        searchPlaceholder="Buscar usuario..."
        [enableHeaderSort]="true"
        [enableSort]="true"
        [serverSideSort]="true"
        [sortState]="currentSort"
        (sortChange)="onSortChange($event)"
        (toolbarSortChange)="onSortChange($event)"
        [enableColumnVisibility]="true"
        [enableDensity]="true"
        primaryActionLabel="Crear usuario"
        primaryActionMobileLabel="Nuevo"
        [cellTemplate]="cellContent"
        (searchChange)="onToolbarSearch($event)"
        (filterRemove)="onFilterRemove($event)"
        (primaryActionClick)="createUser()"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)">
        <button toolbarActions mat-icon-button type="button" (click)="viewAdminActivity()"
          matTooltip="Actividad de admin" aria-label="Actividad de admin">
          <mat-icon>history</mat-icon>
        </button>
        <div filterPanel class="users-filter-panel" [formGroup]="filterForm">
          <div *ngIf="filterOptionsError" class="filter-options-error" role="alert">
            {{ filterOptionsError }} <button mat-button type="button" (click)="loadFilterOptions()">Reintentar</button>
          </div>
          <fieldset class="users-role-filter" aria-label="Filtros de rol">
            <div class="users-role-filter-fields">
              <div class="users-filter-field">
                <span id="users-filter-role" class="users-filter-label">Rol</span>
                <mat-form-field appearance="fill" subscriptSizing="dynamic">
                  <mat-select aria-labelledby="users-filter-role" [canSelectNullableOptions]="true" formControlName="role">
                    <mat-option [value]="null">Todos</mat-option>
                    <mat-option *ngFor="let role of roleOptions" [value]="role.value">{{ role.label }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <app-unit-selector formControlName="roleUnitId" label="Unidad"
                floatLabel="always" placeholder="Buscar unidad..." [required]="false"
                [unitSource]="roleUnitOptions">
              </app-unit-selector>
            </div>
          </fieldset>
          <div class="users-filter-field">
            <span id="users-filter-hasLocalUser" class="users-filter-label">Miembro vinculado</span>
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <mat-select aria-labelledby="users-filter-hasLocalUser" [canSelectNullableOptions]="true" formControlName="hasLocalUser">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option [value]="true">Sí</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
            </mat-form-field>
          </div>
          <div class="users-filter-field">
            <span id="users-filter-isActive" class="users-filter-label">Activo</span>
            <mat-form-field appearance="fill" subscriptSizing="dynamic">
              <mat-select aria-labelledby="users-filter-isActive" [canSelectNullableOptions]="true" formControlName="isActive">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option [value]="true">Sí</mat-option>
              <mat-option [value]="false">No</mat-option>
            </mat-select>
            </mat-form-field>
          </div>
        </div>
      </app-table-surface>

    <ng-template #cellContent let-column="column" let-row="row">
      <div *ngIf="column === 'username'" class="table-cell-stack table-cell-stack--compact">
        <button type="button" class="users-user-cell users-user-cell--link" (click)="editUser(row)">
          <strong>{{ row.username }}</strong>
        </button>
        <span class="table-cell-line table-cell-line--muted">{{ row.email || '-' }}</span>
      </div>
      <div *ngIf="column === 'rolesMore'" class="user-roles-container user-roles-container--compact">
        <ng-container *ngIf="getUserRoleDetails(row).length; else noRolesMore">
          <div *ngFor="let role of getVisibleRoleDetails(row)" class="role-assignment role-assignment--inline">
            <span class="table-cell-badge" [ngClass]="getRoleBadgeClass(role.label)">
              {{ role.label }}
            </span>
            <span *ngIf="role.unitName || role.hasUnit" class="table-cell-meta-chip">
              <mat-icon *ngIf="getRoleUnitIcon(role) === 'church-group'; else compactCommunityRoleIcon" svgIcon="church-group"></mat-icon>
              <ng-template #compactCommunityRoleIcon>
                <mat-icon>{{ getRoleUnitIcon(role) }}</mat-icon>
              </ng-template>
              {{ role.unitName || 'Unidad asignada' }}
            </span>
          </div>
          <span *ngIf="getHiddenRoleCount(row) > 0" class="more-roles-badge">
            +{{ getHiddenRoleCount(row) }} mas
          </span>
        </ng-container>
        <ng-template #noRolesMore>
          <span class="table-cell-empty">-</span>
        </ng-template>
      </div>

      <div *ngIf="column === 'lastActivity'" class="table-cell-line table-cell-line--muted">
        <mat-icon>history</mat-icon>
        <span>{{ formatDateTime(row.lastActivityAtUtc) }}</span>
      </div>

      <div *ngIf="column === 'actions'" class="users-row-actions">
        <a *ngIf="row.linkedMember; else memberActionsButton" mat-icon-button
          [routerLink]="['/people', row.linkedMember.personId]"
          [matTooltip]="'Ver ficha de ' + row.linkedMember.fullName"
          [attr.aria-label]="'Ver ficha de ' + row.linkedMember.fullName">
          <mat-icon>badge</mat-icon>
        </a>
        <ng-template #memberActionsButton>
          <button mat-icon-button type="button" (click)="createMember(row)"
            matTooltip="Crear miembro" [attr.aria-label]="'Crear miembro para ' + row.username">
            <mat-icon>person_add</mat-icon>
          </button>
          <button mat-icon-button type="button" (click)="associateMember(row)"
            matTooltip="Asociar miembro" [attr.aria-label]="'Asociar miembro a ' + row.username">
            <mat-icon>link</mat-icon>
          </button>
        </ng-template>
        <mat-slide-toggle [checked]="row.enabled" [hideIcon]="true" (change)="toggleStatus(row, $event)"
          [disabled]="isStatusUpdating(row.id)"
          [matTooltip]="row.enabled ? 'Desactivar usuario' : 'Activar usuario'"
          [aria-label]="(row.enabled ? 'Desactivar usuario ' : 'Activar usuario ') + row.username">
        </mat-slide-toggle>
      </div>
    </ng-template>
    </mat-card-content>
  </mat-card>
</section>
